import { render } from "./pay-methods.vue?vue&type=template&id=22606e0e&scoped=true"
import script from "./pay-methods.vue?vue&type=script&lang=js"
export * from "./pay-methods.vue?vue&type=script&lang=js"

import "./pay-methods.vue?vue&type=style&index=0&id=22606e0e&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22606e0e"]])

export default __exports__